"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentSchedulingOption = void 0;
var HlPaymentSchedulingOption_1 = require("@leavy/lv-homesharing-pricing-srv/lib/pricing/domain/HlPaymentSchedulingOption");
Object.defineProperty(exports, "PaymentSchedulingOption", { enumerable: true, get: function () { return HlPaymentSchedulingOption_1.HlPaymentSchedulingOption; } });
//# sourceMappingURL=PaymentSchedulingOption.js.map